/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Revoke_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not disconnect this mailbox." |
*
* @param {Connections_Outlook_Revoke_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_revoke_error = /** @type {((inputs?: Connections_Outlook_Revoke_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Revoke_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Postfach konnte nicht getrennt werden.")
	return /** @type {LocalizedString} */ ("Could not disconnect this mailbox.")
});